//Get Reducer Call--->
export const getTallyRequest = (page: number, size: number, search: string, from_date: string, to_date: string) => ({
    type: 'GET_TALLY_REQUEST',
    payload: { page, size, search, from_date, to_date },
});

export const getTallySuccess = (data: any) => ({
    type: 'GET_TALLY_SUCCESS',
    payload: { data },
});

export const getTallyFailure = (data: string) => ({
    type: 'GET_TALLY_FAILURE',
    payload: { data },
});

export const resetGetTally = () => ({
    type: 'RESET_GET_TALLY',
});

//Create Reducer Call--->
export const createTallyRequest = (data: any) => ({
    type: 'CREATE_TALLY_REQUEST',
    payload: data,
});

export const createTallySuccess = (data: any) => ({
    type: 'CREATE_TALLY_SUCCESS',
    payload: { data },
});

export const createTallyFailure = (data: string) => ({
    type: 'CREATE_TALLY_FAILURE',
    payload: { data },
});

export const resetCreateTally = () => ({
    type: 'RESET_CREATE_TALLY',
});

//Update Reducer Call--->
export const updateTallyRequest = (data: any, id: string) => ({
    type: 'UPDATE_TALLY_REQUEST',
    payload: { data, id },
});

export const updateTallySuccess = (data: any) => ({
    type: 'UPDATE_TALLY_SUCCESS',
    payload: { data },
});

export const updateTallyFailure = (data: string) => ({
    type: 'UPDATE_TALLY_FAILURE',
    payload: { data },
});

export const resetUpdateTally = () => ({
    type: 'RESET_UPDATE_TALLY',
});
//Delete Reducer Call--->
export const deleteTallyRequest = (id: string) => ({
    type: 'DELETE_TALLY_REQUEST',
    payload: { id },
});

export const deleteTallySuccess = (data: any) => ({
    type: 'DELETE_TALLY_SUCCESS',
    payload: { data },
});

export const deleteTallyFailure = (data: string) => ({
    type: 'DELETE_TALLY_FAILURE',
    payload: { data },
});

export const resetDeleteTally = () => ({
    type: 'RESET_DELETE_TALLY',
});
